import { FC, useEffect, useState } from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    Grid,
    InputLabel,
    OutlinedInput,
    Typography,
    useMediaQuery,
    useTheme
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Tenant } from 'types/tenant';

interface ChildComponentProps {
    tenant?: Tenant;
    onAdd(tenant: Tenant): any;
    onClose(): any;
}

const TenantAdd: FC<ChildComponentProps> = (props) => {
    const { tenant, onAdd, onClose } = props;
    const [open, setOpen] = useState(false);
    const [currentTenant, setCurrentTenant] = useState(tenant);
    const { t } = useTranslation();
    const theme = useTheme();
    const mobileDevice = useMediaQuery(theme.breakpoints.down('md'));

    useEffect(() => {
        if (tenant === undefined) {
            setOpen(false);
        } else {
            setOpen(true);
        }
    }, [tenant]);

    return (
        <>
            <Dialog open={open} onClose={onClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title"> {t('ADD_NEW_TENANT')} </DialogTitle>
                <DialogContent sx={{ paddingTop: '6px!important', width: mobileDevice ? window.innerWidth - 65 : 500 }}>
                    <Grid container>
                        <Grid item md={8} xs={12} sx={{ mb: 2 }}>
                            <FormControl fullWidth required>
                                <InputLabel>{t('NAME')}</InputLabel>
                                <OutlinedInput
                                    defaultValue={currentTenant?.name}
                                    onChange={(d) => {
                                        const e = {
                                            ...currentTenant!,
                                            name: d.target.value
                                        };
                                        setCurrentTenant(e);
                                    }}
                                    type="text"
                                    label={t('NAME')}
                                />
                            </FormControl>
                        </Grid>
                    </Grid>
                    <Typography marginTop="5px"> * {t('MANDATORY_FIELDS')}</Typography>
                </DialogContent>
                <DialogActions sx={{ marginRight: '16px' }}>
                    <Button
                        onClick={() => {
                            setCurrentTenant(undefined);
                            onClose();
                        }}
                        autoFocus
                        style={{
                            border: '2px solid',
                            borderColor: theme.palette.secondary.main,
                            borderRadius: 7
                        }}
                    >
                        <Typography sx={{ color: theme.palette.primary.main }}> {t('CANCEL')}</Typography>
                    </Button>
                    <Button
                        style={{
                            border: '2px solid',
                            borderColor: theme.palette.primary.main,
                            borderRadius: 7,
                            background: theme.palette.primary.main
                        }}
                        onClick={() => {
                            onAdd(currentTenant!);
                        }}
                    >
                        <Typography style={{ color: '#fff' }}>{t('ADD')}</Typography>
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default TenantAdd;
